import { FormProvider } from 'react-hook-form';
import Select from './inputs/Select';
import Input from './inputs/Input';
import DateRange from './inputs/DateRange';
import Textarea from './inputs/Textarea';
import MultiSelect from './inputs/MultiSelect';
import Checkbox from './inputs/Checkbox';

export default {
  Provider: FormProvider,
  Select,
  Input,
  DateRange,
  Textarea,
  MultiSelect,
  Checkbox,
};
